export default __webpack_public_path__ + "static/media/app-preview.61deba7d.webp";